import React, { createContext, useEffect } from 'react'
import { Box, Stack } from '@mui/material'
import SeoCsLearning from '../seo/SeoCsLearning'
import { useIntl } from 'react-intl'
import SeoMgLearning from '../seo/SeoMgLearning'
import ContactBlock from './ContactBlock'
import { useDispatch, useSelector } from 'react-redux'
import { IReducer } from 'src/interface'
import { getEducationProducts } from 'src/actions'
import { useCookies } from 'react-cookie'

type EducationLayoutType = {
  children: React.ReactNode
}

export const ProductContext = createContext<string>('')

const EducationLayout = ({ children }: EducationLayoutType) => {
  const intl = useIntl()
  const productValue = window.location.pathname.includes('/matrixgold') ? 'MatrixGold' : 'CounterSketch'
  const dispatch = useDispatch()
  const educationProducts = useSelector((state: IReducer) => state.stripeProductsReducer.educationProducts)
  const countryCode = useSelector((state: IReducer) => state.stripeProductsReducer.countryCode)
  const [cookies] = useCookies(['country_code'])

  useEffect(() => {
    if (cookies.country_code === undefined) {
      return
    }
    const isCountryCodeChanged = cookies.country_code !== countryCode
    const isProductMissing = !educationProducts?.some(
      (product) => product.metadata.category === productValue.toLowerCase()
    )
    if (isCountryCodeChanged || isProductMissing) {
      dispatch(getEducationProducts(cookies.country_code, productValue))
    }
  }, [cookies.country_code])

  return (
    <ProductContext.Provider value={productValue}>
      <Box sx={{ width: '100%', background: '#1d1d1d' }} data-cy='education-container'>
        {productValue === 'CounterSketch' ? (
          <SeoCsLearning
            title={intl.formatMessage({ id: 'seo.countersketch.learning.title' })}
            description={intl.formatMessage({ id: 'seo.countersketch.learning.description' })}
          />
        ) : (
          <SeoMgLearning
            title={intl.formatMessage({ id: 'seo.matrixgold.learning.title' })}
            description={intl.formatMessage({ id: 'seo.matrixgold.learning.description' })}
          />
        )}
        <Stack
          component='section'
          sx={{
            maxWidth: 1200,
            margin: 'auto',
            paddingY: 6,
            paddingX: 2,
            alignItems: 'center',
            gap: 8
          }}
        >
          {children}
          <ContactBlock />
        </Stack>
      </Box>
    </ProductContext.Provider>
  )
}

export default EducationLayout
